<footer>
    <div class="row">
        <div class="column medium-4">
            <div class="address">
                <strong>دفتر مرکزی</strong>
                <address>
                    تهران، خیابان ولی عصر، بالا تر از خیابان شهید بهشتی، بعد از کوچه نادر، شماره ۲۱۱۳ </address>
                <dl>
                    <dd>کد پستی:</dd>
                    <dt>۱۵۱۱۷۱۳۳۱۱</dt>
                    <dd>مرکز پشتیبانی گروه آبان:</dd>
                    <dt><a href="tel:85510"> ۸۵۵۱۰</a></dt>
                    <dd>پست الکترونیک:</dd>
                    <dt ><a href="mailto:aban@aban.net">aban@aban.net</a></dt>
                </dl>
            </div>
        </div>
        <div class="column medium-4">
            <div class="work-time">
                <strong>ساعات کاری</strong>
                <dl>
                    <dd>شنبه تا چهار شنبه از ساعت ۷ الی ۱۶</dd>
                </dl>
            </div>
            <div class="info">
                <strong>بیانیه رفع مسئولیت</strong>
                <p></p>
                <p>قبل از استفاده از محتوی و خدمات این سایت به دقت این بیانیه را مطالعه فرمایید. </p>
                <p></p>
                <a target="_blank" [routerLink]="['/disclaimer']">ادامه</a>
            </div>
        </div>
        <div class="column medium-4">
            <div class="address">
                <strong>عضویت در خبرنامه</strong>
                <a style="font-size:12px;" href="/nl" onclick="window.open(this.href, 'خبرنامه',
    'left=20,top=20,width=460,height=600,toolbar=1,resizable=0'); return false;">جهت عضويت در خبرنامه گزارش تحليلي
                    روزانه کلیک کنید.</a>
            </div>
            <div class="info">
                <a referrerpolicy="origin" target="_blank"
                    href="https://trustseal.enamad.ir/?id=175304&amp;Code=nZ6joKImqMdmSeJoUkZL"><img
                        referrerpolicy="origin"
                        src="https://Trustseal.eNamad.ir/logo.aspx?id=175304&amp;Code=nZ6joKImqMdmSeJoUkZL" alt=""
                        style="cursor:pointer" id="nZ6joKImqMdmSeJoUkZL"></a>
            </div>
        </div>
    </div>
    <div class="copy-right">
        <div class="row">
            <div class="column medium-12">
                <img class="logoimg" src="../../assets/images/footer-logo.png">
                <strong>
                    © کلیه حقوق این وب سایت متعلق به شرکت کارگزاری آبان می باشد. </strong>
                <img class="imgimg" src="../../assets/images/footer-img.png">
            </div>
        </div>
    </div>
</footer>